var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserBlockFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_29110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C4.0335 1 3.25 1.7835 3.25 2.75C3.25 3.7165 4.0335 4.5 5 4.5C5.9665 4.5 6.75 3.7165 6.75 2.75C6.75 1.7835 5.9665 1 5 1ZM2.25 2.75C2.25 1.23122 3.48122 0 5 0C6.51878 0 7.75 1.23122 7.75 2.75C7.75 4.26878 6.51878 5.5 5 5.5C3.48122 5.5 2.25 4.26878 2.25 2.75Z",
    fill: "#FF9600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 7.5C8.73122 7.5 7.5 8.73122 7.5 10.25C7.5 11.7688 8.73122 13 10.25 13C11.7688 13 13 11.7688 13 10.25C13 8.73122 11.7688 7.5 10.25 7.5ZM6.5 10.25C6.5 8.17893 8.17893 6.5 10.25 6.5C12.3211 6.5 14 8.17893 14 10.25C14 12.3211 12.3211 14 10.25 14C8.17893 14 6.5 12.3211 6.5 10.25Z",
    fill: "#FF9600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9037 7.5964C13.099 7.79166 13.099 8.10824 12.9037 8.3035L8.30375 12.9035C8.10849 13.0988 7.7919 13.0988 7.59664 12.9035C7.40138 12.7082 7.40138 12.3917 7.59664 12.1964L12.1966 7.5964C12.3919 7.40114 12.7085 7.40114 12.9037 7.5964Z",
    fill: "#FF9600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88463 6.11884C4.61806 5.95224 5.37966 5.95358 6.1125 6.12277C6.38157 6.18488 6.54933 6.45336 6.48721 6.72243C6.42509 6.99149 6.15661 7.15925 5.88755 7.09714C5.30157 6.96185 4.6926 6.96078 4.10615 7.094C3.5197 7.22722 2.97095 7.49128 2.50093 7.86644C2.0309 8.24161 1.65177 8.71817 1.39186 9.26049C1.13195 9.80282 0.998003 10.3969 1.00002 10.9983L1.00003 10.9999L1.00003 12H4.50003C4.77617 12 5.00003 12.2238 5.00003 12.4999C5.00003 12.7761 4.77617 13 4.50003 13H0.500025C0.223883 13 2.53215e-05 12.7761 2.53215e-05 12.4999V11.0008C-0.00236959 10.249 0.165149 9.50631 0.49007 8.82832C0.815115 8.15007 1.28927 7.55407 1.8771 7.08488C2.46492 6.61569 3.1512 6.28545 3.88463 6.11884Z",
    fill: "#FF9600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_29110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlockFilled);
export default __webpack_public_path__ + "static/media/user-block-filled.a986443ecde2fafc802dfee6c2c4fad6.svg";
export { ForwardRef as ReactComponent };